import { Button } from "@mui/material";
import { HoldingsListStyles } from "../common/styles/HoldingsList.styles";

interface IAddressActionButtonProps {
  el: any;
  handleRowClick: (el: any) => void;
  setCopy: React.Dispatch<React.SetStateAction<boolean>>;
}

const AddressActionButton: React.FC<IAddressActionButtonProps> = ({
  el,
  handleRowClick,
  setCopy,
}: IAddressActionButtonProps) => {
  const classes = HoldingsListStyles();

  const isVerify =
    el.status === "Testing Pending" ||
    el.status === "Testing Sent" ||
    el.status === "Email 2FA required";

  const copyToClipboard = (address: string) => {
    navigator.clipboard.writeText(address ? address : "");
    setCopy((prev) => !prev);
    setTimeout(() => {
      setCopy((prev) => !prev);
    }, 1000);
  };

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (isVerify && el.status !== "Testing Pending") {
      handleRowClick(el);
    } else {
      copyToClipboard(el.address);
    }
  };

  return (
    <Button
      disableRipple
      className={isVerify ? classes.verifyButton : classes.copyButton}
      variant="outlined"
      sx={{
        borderRadius: "10px",
        textTransform: "capitalize",
        color: "#7B858B",
        border: "1px solid var(--neutral-100, #E5E7E8)",
      }}
      disabled={isVerify && el.status === "Testing Pending"}
      onClick={handleClick}>
      {isVerify ? "Verify" : "Copy"}
    </Button>
  );
};

export default AddressActionButton;
